import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Card, Button, Col, Row, Container, Tabs, Tab } from "react-bootstrap";
import ConfirmModal from "../../../../components/ConfirmModal";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import { getQueryString } from "../../../../utils/Query";
import { HeadDetail } from "../../../../components/Perform/HeadDetail";
import { DetailEquip } from "../../../../components/Perform/DetailEquip";
import ServiceRequestService from "../../../../services/servicerequest.service";
import { useLoading } from "../../../../context/LoadingContext";
import ImageViewing from "./imageViewPrint";
import { Helmet } from "react-helmet-async";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import SignPage from "../../../../components/Perform/SignPage";
import FileUploadsService from "../../../../services/fileupload.service";

export default function DetailCloseJob() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { loading, setLoading } = useLoading(false);
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [previousData, setPreviousData] = useState([]);
  const [equipData, setEquipData] = useState([]);
  const [equipIndex, setEquipIndex] = useState(0);
  const [optionReason, setOptionReason] = useState([]);
  const [defaultTableData, setDefaultTableData] = useState([]);

  const [isAccecpt, setIsAccept] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const destination = "signature"
  const isSign = state.data?.TechnicianPlan?.TechWorkClosed
  const [imgSign, setImgSign] = useState(isSign);
  const [showImageViewing, setShowImageViewing] = useState(false);

  const columns = {
    Standard: [{
      name: "detail",
      label: "ขั้นตอนการปฏิบัติงาน",
      type: "text",
      readOnly: true,
      width: "250px"
    },
    {
      name: "priority",
      label: "Priority",
      readOnly: true,
      width: "180px"
    },
    {
      name: "reason",
      label: "เหตุผลที่ข้ามขั้นตอน",
      type: "select",
      disabled: true,
      noneAsync: true,
      filterBy: ["Reason_Desc"],
      options: initializeSetOption({
        key: "Id",
        label: "Reason_Desc",
        dataset: optionReason
      }),
      width: "250px"
    },
    {
      name: "file",
      label: "เพิ่มรูป",
      type: "addImage",
      disabled: true
    },
    {
      name: "",
      label: "ดูรูปภาพ",
      type: "viewImage"
    },
    {
      name: "remark",
      label: "หมายเหตุ",
      readOnly: true,
      type: "text"
    },
    ],
    Record: [
      {
        name: "detail",
        label: "ขั้นตอนการปฏิบัติงาน",
        type: "text",
        readOnly: true,
        width: "350px"
      },
      {
        name: "standard_value",
        label: "ค่ามาตรฐาน",
        readOnly: true,
      },
      {
        name: "record_value",
        label: "ค่าที่จดบันทึก",
        readOnly: true,
      },
      {
        name: "unit",
        label: "หน่วย",
        width: "100px",
        readOnly: true
      },
      {
        name: "file",
        label: "เพิ่มรูป",
        type: "addImage",
        disabled: true
      },
      {
        name: "",
        label: "ดูรูปภาพ",
        type: "viewImage"
      },
      {
        name: "remark",
        label: "หมายเหตุ",
        readOnly: true,
      },
    ],
    Check: [
      {
        name: "equip_no",
        label: "รหัสอุปกรณ์/อะไหล่",
        type: "text",
        width: "200px",
        readOnly: true
      },
      {
        name: "equip_detail",
        label: "รายละเอียดอุปกรณ์/อะไหล่",
        readOnly: true,
        width: "250px"
      },
      {
        name: "model_number",
        label: "Model Number",
        readOnly: true,
        width: "180px"
      },
      {
        name: "lumsum",
        label: "สัญญา LumSum",
        width: "200px",
        readOnly: true
      },
      {
        name: "expire_date",
        label: "วันหมดอายุ",
        readOnly: true,
      },
      {
        name: "check_date",
        label: "วันที่เช็คเปลี่ยน",
        readOnly: true
      },
      {
        name: "next_start",
        label: "วันที่เปลี่ยนครั้งต่อไประหว่าง",
        width: "250px",
        readOnly: true
      },
      {
        name: "end_start",
        label: "ถึงวัน",
        readOnly: true
      },
      {
        name: "plan_status",
        label: "สถานะตามแผน",
        readOnly: true
      },
      {
        name: "actual_status",
        label: "สถานะจริง",
        type: "select",
        disabled: true,
        noneAsync: true,
        filterBy: ["Status"],
        options: initializeSetOption({
          key: "Status",
          label: "Status",
          dataset: [
            { Status: "เช็ค" },
            { Status: "เปลี่ยน" }
          ]
        })
      },
      {
        name: "detail",
        label: "รายละเอียดการทำงาน",
        type: "select",
        disabled: true,
        noneAsync: true,
        filterBy: ["Status"],
        options: initializeSetOption({
          key: "Status",
          label: "Status",
          dataset: optionReason
        }),
        width: "250px",
      },
      {
        name: "use_num",
        label: "จำนวนที่ใช้",
        readOnly: true,
      },
      {
        name: "use",
        label: "Use Flag",
        type: "select",
        noneAsync: true,
        disabled: true,
        filterBy: ["Status"],
        options: optionReason,
        options: initializeSetOption({
          key: "Status",
          label: "Status",
          dataset: [
            { Status: "Y", Use: true },
            { Status: "N", Use: false }
          ]
        })
      },
      {
        name: "file_before",
        label: "เพิ่มรูปก่อนทำ",
        type: "addImage",
        width: "140px",
        disabled: true
      },
      {
        name: "",
        label: "ดูรูปก่อนทำ",
        type: "viewImage",
        width: "140px",
      },
      {
        name: "file_after",
        label: "เพิ่มรูปหลังทำ",
        type: "addImage",
        width: "140px",
        disabled: true
      },
      {
        name: "",
        label: "ดูรูปหลังทำ",
        type: "viewImage",
        width: "140px",
      },
    ],
    Special: [
      {
        name: "detail",
        label: "รายละเอียดข้อกำหนดเพิ่มเติมตามสัญญา",
        type: "text",
        width: "400px",
        readOnly: true
      },
      {
        name: "other",
        label: "ข้อกำหนดเพิ่มเติมอื่นๆ",
        readOnly: true,
        width: "300px"
      },
      {
        name: "pm_no",
        label: "PM/ครั้งที่",
        readOnly: true,
        width: "180px"
      },
    ]
  }

  const headField = [
    {
      name: "tech_mas_name",
      label: "ช่างผู้ปฏิบัติงาน",
      className: { label: "mb-3" },
      type: "text",
      // value: defaultData.tech_name,
      size: "2_25"
    },
    {
      name: "contract_no",
      label: "สัญญาเลขที่",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData.tech_name,
      size: "2_25"
    },
    {
      name: "contract_type",
      label: "ประเภทสัญญา",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData.tech_name,
      size: "2_25"
    },
    {
      name: "start_contract",
      label: "วันที่เริ่มสัญญา",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData.tech_name,
      size: "2_25"
    },
    {
      name: "end_contract",
      label: "วันสิ้นสุดสัญญา",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData.tech_name,
      size: "2_25"
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData.team,
      size: "2_25"
    },
    {
      name: "project_no",
      label: "เลขที่โครงการ",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData.team,
      size: "4_5"
    },

    {
      name: "start",
      label: "วันที่ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: "2_25",
    },
    {
      name: "status_",
      label: "สถานะสาขา",
      classNames: { label: "mb-3" },
      size: "2_25",
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: "2_25",

    },
    {
      name: "cus_no",
      label: "เลขที่สาขา",
      classNames: { label: "mb-3" },
      size: "2_25",

    },
    {
      name: "cus_name",
      label: "ชื่อลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: "6_25",
    },
  ];

  const { seq_no } = useParams()
  useEffect(() => {
    setPreviousData(state?.data)
    getData()
    if (isSign?.TechWorkClosedFile?.file_path) {
      getServiceRequest({
        showAlert: () => { },
        setLoading: () => { },
        serviceRequest: FileUploadsService.getFileUploads(destination, isSign.TechWorkClosedFile.file_path),
        callback: (res) => {
          setImgSign(URL.createObjectURL(res))
        }
      });
    }
  }, [])

  function onChangeCallback(data) {
    setEquipData(data)
  }

  function getData() {
    // const page = search?.page || currentPage
    const q = getQueryString({
      seq_no: state?.data?.Seq_No,
      page: 1,
      limit: 100
    })

    let defaultData = {}
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getItemStepDes(q),
      callback: (res) => {
        const arrayStep = res.map(el => ({
          // id: el.Id,
          item_step_id: el.Item_Step_Id,
          item_step_des_id: el.Id, //el.Item_Step_Id,
          detail: el.Item_Step_Des,
          priority: el.Item_Step_Priority,
          reason: el.Item_Step_Reason,
          remark: "",
          file: []
        }))
        defaultData = { ...defaultData, tableStandard: arrayStep }
      }
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getContractSpec(q),
      callback: (res) => {
        const arraySp = res.map(el => ({
          detail: el.Con_Spec_Des,
          other: el.remark,
          pm_no: el.PM_Of_Work,
          id: el.Id,
        }))
        defaultData = { ...defaultData, tableSpecial: arraySp }
      }
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getStandardRec(q),
      callback: (res) => {
        const array = res.map(item => ({
          detail: item.Item_Record_Des,
          standard_value: item.Record_Value,
          record_value: item.Actual_Value,
          unit: item.Record_UOM,
          remark: item.Remark,
          id: item.Id,
          file: []
        }))
        defaultData = { ...defaultData, tableRecord: array }
      }
    });

    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: ServiceRequestService.getFindJobItem(q),
      callback: async (res) => {
        setDefaultTableData(defaultData)

        if (!res.data?.length) return
        setLoading('loading')
        const arr = []
        const data = res.data
        const defaultEq = res.data[0].BillOfReqDt?.map(items => {
          const newArray = []
          items.Item.ChildBoms?.forEach(ele => {
            const data = items.ServiceRequest?.TechWorkJob?.TechWorkChecks.find(ch => ch.item_child_id == ele.Id)
            newArray.push({
              // id = items?.ServiceRequest?.id
              id: ele.Id,
              equip_no: ele.Item.Item_Code,
              equip_detail: ele.Item.Item_Name_TH || ele.Item.Item_Name_EN,
              model_number: ele.Item.Item_Model,
              lumsum: ele?.Foc?.FOC_ReasonName,
              expire_date: "",
              check_date: "",
              next_start: "",
              end_start: "",
              plan_status: "",//data.plan_status,
              actual_status: data?.actual_status,
              detail: data?.reason_id,
              use_num: data?.item_use_qty,
              use: items.Use_Status,
              file_before: [],
              file_after: []
            })
          })
          const main = {
            Seq_No: data[0].SeqOthersJob?.Seq_Oth_No ||
              data[0].SeqPmJob?.Seq_Pm_No ||
              data[0].SeqRepairJob?.Seq_Serv_No ||
              data[0].SeqInstallJob?.Seq_Inst_No,
            Bill_Of_Req_Dt_Id: items.Id,
            Bill_Of_Hd_Id: items.Bill_Of_Hd_Id,
            Id: data[0].Id,
            Job_Type: data[0].Job_Type_Name || state.arrJobType?.find(j => j.Id == data[0].Job_Type_Id)?.Job_Type_Name,
            No: "", //pm_no.pm_item   job_type_sub_mas.job_type_sub_name
            ProdSetMcId: items?.Item?.ProdSetMc?.Id,
            Sq: items?.Item?.ProdSetMc?.Seq_Work,
            Item_Name: items?.Item.Item_Name_TH || items?.Item.Item_Name_EN,
            Project_No: items?.Project_No || items?.Item.Item_Code,
            Start: "", //job_start_date
            End: "",
            Ticket: "", //cus_ticket_no
            Location: items?.Item?.ProdSetMc?.Mc_Location,
          }

          return {
            ...main,
            Id: items.Id,
            serviceReqDt: items.ServiceRequestDt?.TechWorkJob,
            tableCheck: newArray,
            tableSpecial: defaultData?.tableSpecial
          }
        })
        setEquipData(defaultEq)
      }
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getReason(q),
      callback: (res) => { setOptionReason(res) }
    });

  }

  useEffect(() => {
    if (loading == 'loading') {
      setLoading(false)

      const all = equipData.map(items => {
        const arrStandard = [], arrRecord = [], arrCheck = []
        items.serviceReqDt?.TechWorkSteps?.map(st => {
          const df = defaultTableData.tableStandard.find(t => t.item_step_des_id == st.item_step_des_id)
          arrStandard.push({
            work_step_id: st?.id,
            item_step_id: st.item_step_id,
            item_step_des_id: st?.item_step_des_id,
            detail: st?.Item_Step_Des || df?.detail,
            priority: st?.Item_Step_Priority || df?.priority,
            reason: st?.reason_id,
            remark: st?.remark,
            file: st?.TechWorkStepFile
          })
        })
        items.serviceReqDt?.TechWorkRecords?.map(rc => {
          const df = defaultTableData.tableRecord.find(t => t.id == rc.item_step_id)
          arrRecord.push({
            detail: rc?.Item_Record_Des || df?.detail,
            standard_value: rc?.Record_Value || df?.standard_value,
            record_value: rc?.actual_value,
            unit: rc?.Record_UOM || df?.unit,
            remark: rc?.remark,
            work_record_id: rc?.id,
            item_step_id: rc?.item_step_id || df?.id,
            file: rc?.TechWorkRecordFiles
          })
        })
        items.serviceReqDt?.TechWorkChecks?.map((ch, i) => {
          const df = equipData.find(t => t.sid == ch.id)
          arrCheck.push({
            ...items.tableCheck[i],
            actual_status: ch?.actual_status,
            use_num: ch?.item_use_qty,
            plan_status: ch?.plan_status,
            detail: ch?.reason_id,
            file_before: ch?.TechWorkCheckFiles.filter(f => f.type == "before"),
            file_after: ch?.TechWorkCheckFiles.filter(f => f.type == "after")
          })
        })
        return {
          ...items,
          tableCheck: arrCheck.length ? arrCheck : items?.tableCheck,
          tableStandard: arrStandard.length ? arrStandard : defaultTableData?.tableStandard,
          tableRecord: arrRecord.length ? arrRecord : defaultTableData?.tableRecord
        }
      })

      setEquipData(all)
    }
  }, [equipData])

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Perform Service Request Page" />
      </Helmet>

      <Container fluid className="p-0" id="tab_team">
        <Tabs
          justify
          defaultActiveKey={state?.name || "CloseJob"}
          className="mb-3"
        >
          <Tab eventKey="ServiceReq" title="ปฏิบัติงานตาม Service Request" disabled>
          </Tab>
          <Tab eventKey="ServiceReqDetail" title="ข้อมูลการปฏิบัติงานตาม Service Request" disabled>
          </Tab>
          <Tab eventKey="CloseJob" title="ปิดงาน">
            {!showImageViewing ?
              !isAccecpt ?
                <>
                  <Card className="m-1 mb-4 p-4 border-0">
                    <Card.Body>
                      <div className="pb-4 fs-2 text-center">
                        รายละเอียดการปฏิบัติงาน
                      </div>

                      <HeadDetail field={headField} data={previousData || {}} disableAll />
                    </Card.Body>
                  </Card>

                  <DetailEquip
                    data={equipData}
                    columns={columns}
                    setEquipData={setEquipData}
                    equipIndex={equipIndex}
                    setEquipIndex={setEquipIndex}
                    onChangeCallback={onChangeCallback}
                    callbackImage={setShowImageViewing}
                  />

                  <Card className="m-1 mb-4 p-4 border-0">

                    <Row className="justify-content-center mt-3">
                      <Col className="col-auto">
                        {isSign
                          ? <center>
                            <img src={imgSign} alt={isSign.TechWorkClosedFile?.file_path} />
                            <br /><br />
                          </center>
                          :
                          <Button
                            variant="success"
                            className="me-2 ms-3 mb-3 py-2 px-6 text-dark rounded-pill"
                            onClick={() => setIsAccept(true)}
                          >
                            รับงาน
                          </Button>
                        }
                        <center>
                          <Button
                            variant="outline-secondary"
                            className="ms-2 px-5 mb-3 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                            onClick={() => navigate("/service_work/perform", {
                              state: { name: "CloseJob" }
                            })}
                          >
                            ย้อนกลับ
                          </Button>
                        </center>
                      </Col>
                    </Row>
                  </Card>
                </> : (
                  <SignPage
                    data={state.data}
                    setIsAccept={setIsAccept}
                    destination={destination}
                  />
                )
              :
              <ImageViewing
                arrayImage={showImageViewing}
                onClickBack={setShowImageViewing}
                destination="service_request/Image"
              />
            }
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}